import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import parse from "html-react-parser";
import PageHeader from "../../Components/layouts/PageHeader";
import Preloader from "../../Components/Preloader";
import Navbar from "../Menu/Navbar";
import Footer from "./Sections/Footer";
import { toGetWarranty } from "../../apis/actions/warranty.actions";
import { AppDispatch, RootState } from "../../apis/store";
import { FiFileText, FiShield, FiTool } from "react-icons/fi";

const prepareWarrantyHtml = (html: unknown) => {
  if (typeof html !== "string") return "";

  // Odoo's editor adds spacer paragraphs that become very large gaps on the web.
  return html.replace(
    /<p(?:\s[^>]*)?>(?:\s|&nbsp;|<br\s*\/?\s*>)*<\/p>/gi,
    ""
  );
};

const Warranty = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { t, i18n } = useTranslation();
  const { list } = useSelector((state: RootState) => state.warranty.warranty);
  const isArabic = i18n.language.startsWith("ar");

  useEffect(() => {
    dispatch(toGetWarranty(i18n.language));
  }, [dispatch, i18n.language]);

  return (
    <>
      <Navbar type="internal" />
      <Preloader />
      <main className="main">
        <PageHeader
          current={t("services.garranty")}
          banner="assets/imgs/page-header/banner1.png"
          link="warranty"
        />
        <section
          className="ac-warranty-page"
          dir={isArabic ? "rtl" : "ltr"}
          aria-labelledby="warranty-intro-title"
        >
          <div className="container ac-warranty-page__container">
            <header className="ac-warranty-intro">
              <div className="ac-warranty-intro__mark" aria-hidden="true">
                <FiShield />
              </div>
              <div className="ac-warranty-intro__copy">
                <span className="ac-warranty-intro__eyebrow">
                  {isArabic ? "دليل الضمان" : "Warranty guide"}
                </span>
                <h2 id="warranty-intro-title">
                  {isArabic
                    ? "حماية واضحة، من أول يوم"
                    : "Clear coverage, from day one"}
                </h2>
                <p>
                  {isArabic
                    ? "تعرّف على مدة التغطية، متطلبات الصيانة، والشروط الخاصة بكل خدمة."
                    : "Review the coverage period, maintenance requirements, and terms for every service."}
                </p>
              </div>
              <div className="ac-warranty-intro__facts" aria-label={isArabic ? "متطلبات الضمان" : "Warranty requirements"}>
                <span><FiFileText />{isArabic ? "احتفظ بالفاتورة" : "Keep your invoice"}</span>
                <span><FiTool />{isArabic ? "التزم بالصيانة" : "Follow maintenance"}</span>
              </div>
            </header>

            <div className="ac-warranty-page__rule" aria-hidden="true" />

            <div className="ac-warranty-list">
                  {list.map((item: any, index: number) => (
                    <article className="ac-warranty-card" key={item?.id ?? index}>
                      {(item?.name || item?.summary) && (
                        <div className="ac-warranty-card__heading">
                          {item?.name && <h3>{item.name}</h3>}
                          {item?.summary && <p>{item.summary}</p>}
                        </div>
                      )}
                      <div className="ac-warranty-content">
                        {item?.details && parse(prepareWarrantyHtml(item.details))}
                      </div>
                    </article>
                  ))}
            </div>
          </div>
        </section>
      </main>
      <Footer type="external" />
    </>
  );
};

export default Warranty;
